package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.WarningW500Rounded: ImageVector
    get() {
        if (_warningW500Rounded != null) {
            return _warningW500Rounded!!
        }
        _warningW500Rounded = Builder(name = "WarningW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(111.63f, 844.07f)
                quadToRelative(-12.67f, 0.0f, -22.87f, -6.34f)
                quadToRelative(-10.19f, -6.34f, -15.91f, -16.53f)
                quadToRelative(-5.72f, -10.2f, -6.22f, -22.13f)
                quadToRelative(-0.5f, -11.94f, 6.22f, -23.37f)
                lineTo(440.22f, 140.0f)
                quadToRelative(6.71f, -11.43f, 17.53f, -17.03f)
                quadToRelative(10.82f, -5.6f, 22.25f, -5.6f)
                reflectiveQuadToRelative(22.25f, 5.6f)
                quadToRelative(10.82f, 5.6f, 17.53f, 17.03f)
                lineToRelative(367.37f, 635.7f)
                quadToRelative(6.72f, 11.43f, 6.22f, 23.37f)
                quadToRelative(-0.5f, 11.93f, -6.22f, 22.13f)
                quadToRelative(-5.72f, 10.19f, -15.91f, 16.53f)
                quadToRelative(-10.2f, 6.34f, -22.87f, 6.34f)
                lineTo(111.63f, 844.07f)
                close()
                moveTo(183.98f, 756.65f)
                horizontalLineToRelative(592.04f)
                lineTo(480.0f, 246.7f)
                lineTo(183.98f, 756.65f)
                close()
                moveTo(509.22f, 707.3f)
                quadToRelative(11.98f, -11.97f, 11.98f, -29.21f)
                quadToRelative(0.0f, -17.24f, -11.98f, -29.1f)
                quadToRelative(-11.98f, -11.86f, -29.22f, -11.86f)
                reflectiveQuadToRelative(-29.22f, 11.86f)
                quadToRelative(-11.98f, 11.86f, -11.98f, 29.1f)
                quadToRelative(0.0f, 17.24f, 11.98f, 29.21f)
                quadToRelative(11.98f, 11.98f, 29.22f, 11.98f)
                reflectiveQuadToRelative(29.22f, -11.98f)
                close()
                moveTo(508.5f, 588.5f)
                quadTo(520.0f, 577.0f, 520.0f, 560.0f)
                verticalLineToRelative(-117.37f)
                quadToRelative(0.0f, -17.0f, -11.5f, -28.5f)
                reflectiveQuadToRelative(-28.5f, -11.5f)
                quadToRelative(-17.0f, 0.0f, -28.5f, 11.5f)
                reflectiveQuadToRelative(-11.5f, 28.5f)
                lineTo(440.0f, 560.0f)
                quadToRelative(0.0f, 17.0f, 11.5f, 28.5f)
                reflectiveQuadTo(480.0f, 600.0f)
                quadToRelative(17.0f, 0.0f, 28.5f, -11.5f)
                close()
                moveTo(480.0f, 501.67f)
                close()
            }
        }
        .build()
        return _warningW500Rounded!!
    }

private var _warningW500Rounded: ImageVector? = null
